/******************************************************************************************
 *  License Count Column Value Filter
 *******************************************************************************************
 *
 * Takes in the count value, whether or not there's an error state, and whether or not
 * the data is applicable. The output:
 * If errorState is true: '-'
 * If applicable is false: 'N/A' (translated)
 * Otherwise, number-formatted count
 *
 */
(function() {
  

  // eslint-disable-next-line lodash/prefer-lodash-method
  angular.module('rcFilters.licenseCountColumnValue', []).filter(
    'licenseCountColumnValue',
    /* @ngInject */
    function($locale, $filter, $translate) {
      return function(count, errorState, applicable) {
        if (errorState) {
          return '-';
        }
        if (!applicable) {
          return $translate.instant('words.notApplicableShortForm');
        }

        return $filter('numberFormatter')(count);
      };
    }
  );
})();
